import { pipe } from 'rxjs';
import { selectLastTravel } from './last-travel.selector';
import { prop } from 'ramda';

export const selectLastVisitedSystem = pipe(
  selectLastTravel,
  prop('systemIndex'),
);
